export default "__VITE_ASSET__42f0ceb8__"